import { expressEventListener, expressQuerySelectorAll } from "../../common/html";
import { compositeDisposable } from "../../utils/disposable";
import { isTouchDevice } from "../../common/device";

export interface INavigationDesktopDeps {
	activatedElement: (selectedElement: HTMLElement) => void;
	getActiveIndex: () => string;
}
export function CreateNavigationDesktopFirstLevel(container: HTMLElement, deps: INavigationDesktopDeps) {
	const ACTIVE_CLASS = "m-navigation-desktop-first-level__list-item--active";
	const navigationItems = expressQuerySelectorAll<HTMLElement>(container, ".technical-navigation-item");
	const { activatedElement } = deps;

	const disposibles = navigationItems.map((x) => {
		return compositeDisposable([
			expressEventListener(x, "click", () => {
				activatedElement(x);
				navigationItems.forEach((ni) => ni.classList.toggle(ACTIVE_CLASS, ni === x));
			}),
			expressEventListener(x, "mouseover", () => {
				if (isTouchDevice()) return;
				activatedElement(x);
				navigationItems.forEach((ni) => ni.classList.toggle(ACTIVE_CLASS, ni === x));
			}),
		]);
	});

	return {
		close: () => navigationItems.forEach((ni) => ni.classList.toggle(ACTIVE_CLASS, false)),
		dispose: () => disposibles.forEach((x) => x.dispose()),
	};
}
